<template>
  <body style="max-width:1000px;margin:0 auto;">
    <div>
      <loading v-if="is_loading" />
      <div class="box" :style="{ ...box, height: total_height }" v-if="!is_loading">
        <!-- 顶部图片 -->
        <div class="top1">


          <img :src="config_info.theme1_top_img" v-if="config_info.theme1_top_type=='1'" />


          <div v-if="config_info.theme1_top_type=='2'">
            <van-swipe :autoplay="3000" :style="`height:${swiper_height}px;`">
              <van-swipe-item v-for="(image, index) in config_info.theme1_top_carousel_list" :key="index">
                <img :src="image" />
              </van-swipe-item>
            </van-swipe>
          </div>


          <div class="web-player-wrapper" v-if="config_info.theme1_top_type=='3'">
            <video v-show="is_m3u8" id="video" ref="video" width="100%" height="auto" controls="controls"
              autoplay="autoplay" x-webkit-airplay="true" :poster="[poster]" x5-video-player-fullscreen="true"
              preload="auto" playsinline="true" webkit-playsinline x5-video-player-typ="h5">
              <source type="application/x-mpegURL" :src="[config_info.theme1_top_video]">
            </video>

            <video v-show="!is_m3u8" width="100%" height="auto" controls="controls" autoplay="autoplay"
              :src="[config_info.theme1_top_video]"> </video>

          </div>




          <div v-if="config_info.share_type!=1">
            <div class="address"
              :style="`fontSize:${config_info['company_name_font_size']};font-weight:${config_info['company_name_font_bold']}`"
              v-if="!!config_info.company == true || !!config_info.linkman == true || !!config_info.linktel == true">
              <span
                style="`fontSize:${config_info['company_name_font_size']};font-weight:${config_info['company_name_font_bold']}`">
                {{ config_info.company }}
              </span>
              <span
                style="`fontSize:${config_info['company_name_font_size']};font-weight:${config_info['company_name_font_bold']}`">
                {{ config_info.linkman }}
                <font v-if="
                  !!config_info.linkman == true && !!config_info.linktel == true
                ">:</font>
                <a style="color: #000" :href="`tel:${config_info['linktel']}`">
                  {{ config_info.linktel }}
                </a>
                &nbsp;
                <a v-if="!!config_info.linktel == true" style="float: right; margin-top: 2px"
                  :href="`tel:${config_info['linktel']}`">
                  <img src="../assets/tel.png" style="width: 20px; height: 20px" />
                </a>
              </span>
            </div>
          </div>
          <!-- 我的短链内容 -->
          <div v-if="config_info.share_type==1">
            <div class="address"
              :style="`fontSize:${config_info['company_name_font_size']};font-weight:${config_info['company_name_font_bold']}`">
              <span
                style="`fontSize:${config_info['company_name_font_size']};font-weight:${config_info['company_name_font_bold']}`">
                {{ config_info.share_company }}
              </span>
              <span
                style="`fontSize:${config_info['company_name_font_size']};font-weight:${config_info['company_name_font_bold']}`">
                {{ config_info.share_linkman }}
                <font v-if=" !!config_info.share_linkman == true && !!config_info.share_phone == true">:</font>
                <a style="color: #000" :href="`tel:${config_info['share_phone']}`">
                  {{ config_info.share_phone }}
                </a>
                &nbsp;
                <a v-if="!!config_info.share_phone == true" style="float: right; margin-top: 2px"
                  :href="`tel:${config_info['share_phone']}`">
                  <img src="../assets/tel.png" style="width: 20px; height: 20px" />
                </a>
              </span>
            </div>
          </div>
        </div>

        <!-- 底部主要内容 -->
        <div class="bottom1" style="flex:1;overflow: hidden;">
          <!-- 左侧导航栏 -->
          <div class="left1" ref="left1" v-on:scroll="scroll_left()"
            :style="{ width: config_info.left_width + '%', fontSize: config_info.left_font_size, backgroundColor: config_info.left_bg_color }">
            <div :class="['nav',leftcolordisplay==index?'navs':'']" v-for="(item, index) in catList" :key="index"
              :style="{...(leftcolordisplay === index ? check : no_check),textAlign: 'center',width:'100%',display: 'flex',alignItems: 'center', justifyContent: 'center',margin:`${config_info.left_nav_margin_px} 1px`}"
              ref="left2" :id="`cat${item.id}`">

              <div :class="{icon_check: leftcolordisplay == index,icon_no_check: leftcolordisplay != index,}"
                :style="{display: config_info.is_show_left_nav_vertical_bar=='1'?'block':'none'}"></div>

              <p :style="{...(leftcolordisplay === index ? check : no_check),flex:'1',border:config_info.left_nav_border_px,borderRadius:config_info.left_nav_border_radius,margin:'0px'}"
                :class="{leftcolorchange: leftcolordisplay == index,cate1: 1,}"
                @click="getList(item.id, item.type, index)">
                {{ item.name }}
              </p>
            </div>
          </div>
          <!-- 右侧导航内容-->
          <div class="right1" ref="right1" v-on:scroll="scroll_right()"
            :style="{ width: config_info.right_width + '%', backgroundImage: `url(${config_info.theme1_bg_img})`, backgroundSize: '100%',backgroundColor:config_info.right_bg_color}">
            <div v-if="tabcontentShow" :class="['right_good_list', {
              'right_good_list--multi-image': type == 2,
              'right_good_list--image-fill': type == 1 && config_info.is_good_image_fill == '1'
            }]">

              <div v-if="good_classify_info.img && good_classify_info.img != 'null'">
                <img :src="good_classify_info.img" style="width:100%;height:auto;">
              </div>


              <!-- 二级分类菜单 -->
              <div class="erjifenlei" v-if="erji && type == 1"
                :style="`background:${config_info['right_erji_background_color']};font-size:14px;marginTop:4px;`">

                <div class="erjifen1" v-if="  is_second_classify_show_all == 1 ">
                  <div @click="getListall()" :class="['erjifen1-item', quan ? 'erjifen1active' : '']"
                    :style="righterjicolordisplay == -1 ? right_erji_btn_check : right_erji_btn_no_check">
                    全部
                  </div>
                </div>

                <div class="erjifen" v-for="(itemyis, indexyis) in this.diyigelist" :key="indexyis">
                  <div :class="['erjifen-item', righterjicolordisplay == indexyis ? 'erjifenactive' : '']"
                    @click="getListone(indexyis, itemyis.id)"
                    :style="righterjicolordisplay == indexyis ? right_erji_btn_check : right_erji_btn_no_check">
                    {{ itemyis.name }}
                  </div>
                </div>



                <div v-if="this.xianshi && this.zhuangtai == 0" class="erjifen">
                  <div class="erjizhanshi" @click="zhankai()">【展开】</div>
                </div>
                <div v-if="this.xianshi && this.zhuangtai == 1" class="erjifen">
                  <div class="erjizhanshi" @click="shouqi()">【收起】</div>
                </div>
              </div>


              <!-- 商品列表 -->
              <dl class="goods" v-if="type == 1" v-for="item in this.goods" :key="item.id"
                :style="{ borderRadius: config_info.good_out_border_radius, boxShadow: `rgba(0, 0, 0, ${config_info.good_out_border_shadow}) 0px 0px 4px 4px`}">
                <dt @click="navGoodDetail(item)"
                  :style="`border:${config_info['good_img_border_px']}  ${config_info['good_img_border_type']}  ${config_info['good_img_border_color']} ;`">
                  <img :src="item.file" />
                </dt>
                <dd class="title" style="text-align: center">
                  <div @click="navGoodDetail(item)" class="good_name"
                    :style="`color:${config_info['good_name_color']};font-size:${config_info['good_name_size']};font-weight:${config_info['good_name_weight']};width:100%;max-height:100px;line-height:normal;`">
                    {{ item.name }}
                  </div>

                  <span @click="navGoodDetail(item)" class="good_price" v-html="item.market_integral"
                    :style="`color:${config_info['good_price_color']};font-size:${config_info['good_price_size']};font-weight:${config_info['good_price_weight']}`">

                  </span>

                  <button @click="addFanganCart(item.id)" v-if="config_info.is_show_fangan_cart==1"
                    style="background-color: orange;color:#fff;border:none;padding: 3px 8px;">
                    加入采购清单
                  </button>


                </dd>
              </dl>
              <!-- 多图展示 -->
              <dl class="goods1"  style="width:100%;margin:0;" v-if="type == 2" v-for="item in this.goods1" :key="item.index">
                <dt @click="navMultiImage(item)" :style="item.out_url ? 'cursor:pointer;' : ''">
                  <img :src="item.file" />
                </dt>
              </dl>
              <!-- 文件下载 -->
              <div
                style="width: 90%;border: 1px solid rgba(158, 154, 154, 0.58);display: flex;flex-direction: row;height: 80px;border-radius: 10px;"
                class="goods" :v-if="type == 3" v-for="item in this.goods2" :key="item.index">
                <div
                  style="width: 25%;display: flex;flex-direction: column;justify-content: center;align-items: center;">
                  <div
                    v-if="item.extension == 'jpg' ||item.extension == 'jpeg' ||item.extension == 'png' ||item.extension == 'gif'">
                    <img src="../assets/img.svg" width="50px" height="50px;" />
                  </div>
                  <div v-else-if="item.extension == 'xls' || item.extension == 'xlsx'">
                    <img src="../assets/xlsx.svg" width="50px" height="50px;" />
                  </div>
                  <div v-else-if="item.extension == 'doc' || item.extension == 'docx'">
                    <img src="../assets/docx.svg" width="50px" height="50px;" />
                  </div>
                  <div v-else-if="item.extension == 'ppt' || item.extension == 'pptx'">
                    <img src="../assets/ppt.svg" width="50px" height="50px;" />
                  </div>
                  <div v-else-if="item.extension == 'zip' || item.extension == 'rar'">
                    <img src="../assets/zip.svg" width="50px" height="50px;" />
                  </div>
                  <div v-else-if="item.extension == 'pdf'">
                    <img src="../assets/pdf.svg" width="50px" height="50px;" />
                  </div>
                  <div v-else>
                    <img src="../assets/weizhi.svg" width="50px" height="50px;" />
                  </div>
                </div>
                <div style="
                    width: 40%;
                    text-overflow: ellipsis;
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    font-size: 13px;">
                  {{ item.name }}
                </div>
                <div style="
                    display: flex;
                    flex-direction: column;
                    justify-content: space-around;
                    width: 35%;
                    align-items: center;">
                  <van-button type="primary" size="small" @click="downLoadFile(item.file, item.id)">
                    下载文件
                  </van-button>
                  <van-button type="info" size="small" v-clipboard:copy="item.file"
                    @click="copy_log(item.file, item.id)" v-clipboard:success="onCopy" v-clipboard:error="onError">
                    复制链接
                  </van-button>
                </div>
              </div>
              <!-- 礼品册 -->
              <dl class="goods" v-if="type == 4" v-for="item in this.goods3" :key="item.id" @click="goshop(item.id)">
                <dt
                  :style="`border:${config_info['good_img_border_px']}  ${config_info['good_img_border_type']}  ${config_info['good_img_border_color']} ;`">
                  <img :src="item.cover_image" />
                </dt>
                <dd class="title" style="text-align: center">
                  <span class="good_name"
                    :style="`color:${config_info['good_name_color']};font-size:${config_info['good_name_size']};font-weight:${config_info['good_name_weight']}`">
                    {{ item.title }}
                  </span>
                  <span class="good_price"
                    :style="`color:${config_info['good_price_color']};font-size:${config_info['good_price_size']};font-weight:${config_info['good_price_weight']}`">
                    {{ item.market_integral }}
                  </span>
                </dd>
              </dl>
            </div>
            <div class="most">没有更多了</div>
          </div>
        </div>


        <!-- 我的短链 占位专用-->
        <div class="mylian1"
          v-if="(config_info.client_exclusive_sharing==1&&config_info.exclusive_sharing==1&&config_info.client_is_exclusive_recreate_share==1) || (config_info.client_exclusive_sharing==1&&config_info.exclusive_sharing==1&&config_info.client_is_exclusive_recreate_share==0 && config_info.share_type!=1)">
        </div>

        <!-- 我的短链 -->
        <div class="mylian"
          :style="`color:${config_info['bottom_share_btn_content_fontcolor']};font-size:${config_info['bottom_share_btn_content_fontsize']};background:${config_info['bottom_share_btn_bg_color']}`"
          @click="shenglian"
          v-if=" (config_info.client_exclusive_sharing==1&&config_info.exclusive_sharing==1&&config_info.client_is_exclusive_recreate_share==1) || (config_info.client_exclusive_sharing==1&&config_info.exclusive_sharing==1&&config_info.client_is_exclusive_recreate_share==0 && config_info.share_type!=1)">
          {{config_info['bottom_share_btn_content'] }}
        </div>


        <div class="layer" v-if="lay == 1">
          <div class="layer-in">
            <div class="layer-top">
              <div style="color: #000; fontsize: 15px">生成我的链接</div>
              <div class="layer-guan" @click="guanbi">×</div>
            </div>
            <div class="layer-name">公司名称：</div>
            <input type="text" placeholder="您的公司名称" class="layer-shu" name="company" v-model="gongsi" />
            <div v-if="gongsitrue==true" style="color:red">请填写公司名称</div>
            <div class="layer-name">姓名：</div>
            <input type="text" placeholder="联系人姓名" class="layer-shu" name="linkman" v-model="name" />
            <div v-if="nametrue==true" style="color:red">请填写姓名</div>
            <div class="layer-name">手机号：</div>
            <input type="text" placeholder="联系人手机号" class="layer-shu" name="phone" v-model="phone" />
            <div v-if="phonetrue==true" style="color:red">手机号格式不正确</div>

            <div class="layer-share-settings">
              <label>
                <input type="checkbox" v-model="isCustomShare"> 自定义分享标题描述
              </label>
              <div v-if="isCustomShare">
                <div class="layer-name">分享标题：</div>
                <input type="text" placeholder="自定义分享标题" class="layer-shu" v-model="shareTitle" />
                <div v-if="shareTitleTrue" style="color:red">请填写分享标题</div>
                <div class="layer-name">分享描述：</div>
                <input type="text" placeholder="自定义分享描述" class="layer-shu" v-model="shareDesc" />
                <div v-if="shareDescTrue" style="color:red">请填写分享描述</div>
              </div>
            </div>


            <div class="layer-new">保存完成信息以后，请点击右上角…分享!</div>
            <button class="layer-btn" @click="tijiao()">提交信息</button>
          </div>
        </div>


      </div>
    </div>



    <!--
    <div class="brand_cert" v-if="config_info.is_show_brand_cert==1"> <img src="../assets/pinpaiguanfanghuace.png" /></div>

    <div class="fangan_cart" v-if="config_info.is_show_fangan_cart==1" @click="goFanganCart()"><img
        src="../assets/gouwuche.png" />
      <div  class="badge" v-if="this.countall_name!='0'" >{{countall_name}}</div>
    </div>
  -->


    <div class="brand_cert_fangan_cart">
      <img v-if="config_info.is_show_brand_cert==1" src="../assets/guanfanghuace.png" />
      <img v-if="config_info.is_show_fangan_cart==1" @click="goFanganCart()" src="../assets/caigouqingdan.png" />
    </div>



  </body>
</template>

<script>
  import wx from "weixin-js-sdk";
  import {
    Toast
  } from "vant";
  import Vue from 'vue';
  import {
    getCurrentRouteUrl
  } from '../utils/share-url';


  export default {
    data() {
      return {
        lay: 0,
        catList: [],
        tabcontentShow: true,
        goods: [],
        goods1: [],
        goods2: [],
        goods3: [],
        isActive: 0,
        classify_id: "",
        articleTask: "",
        id: "id",
        config_info: "",
        //商品列表、多图展示、文件下载类型
        type: 0,
        leftcolordisplay: 0,
        righterjicolordisplay: -1,
        is_loading: true,
        copy_link: "http://www.baidu.com",
        scroll_left1: 0,
        scroll_right1: 0,
        huace_id: "",
        check: {
          "--check_bg_color": "#a4def2",
          "--check_bg_color1": "#fff",
          "--new_font_color": "#A50610",
          "--new_height": "3.6rem",
        },
        no_check: {
          "--bg_color": "#fff",
          "--new_font_color": "black",
          "--new_height": "3.6rem",
        },
        right_erji_btn_check: {
          "--right_btn_check_bg_color": "#ff5f00",
          "color": "#000",
          "padding": "0 1px",
        },
        right_erji_btn_no_check: {
          "--right_btn_bg_color": "#fff",
          "color": "#000",
          "padding": "0 1px",
        },
        //二级分类
        erji: false,
        diyigelist: [],
        diyigexunilist: [],
        zhanshi: false,
        zhuangtai: 0,
        xianshi: false,
        quan: true,
        cat_id: "",
        type1: "",
        //我的链接
        gongsi: "",
        gongsitrue: false,
        name: "",
        nametrue: false,
        phone: "",
        phonetrue: false,
        heit: 0,
        is_flv: 0,
        is_hls: 0,
        is_m3u8: 1,
        poster: '',
        hls: null,
        swiper_height: '',
        //left1_height: '',
        //right1_height: '',
        total_height: '100vh',
        cart_list: [],
        countall: 0,
        countall_name: '0',
        countgou: 0,
        isCustomShare: false,
        shareTitle: '',
        shareDesc: '',
        shareTitleTrue: false,
        shareDescTrue: false,
        good_classify_info: {}
      }
    },
    methods: {
      //更新顶部的高度，初始化&页面size改变的时候
      updateTop1Height(theme1_top_carousel_bili) {
        let app = this;
        console.log('传入的横纵比是：', theme1_top_carousel_bili);
        // 新增条件判断，限制窗口宽度最大为1000px进行计算
        const baseWidth = Math.min(window.innerWidth, 1000);
        // 根据限制后的宽度计算swiper高度
        app.swiper_height = baseWidth / theme1_top_carousel_bili;
        console.log('页面可视区域宽度（限宽后）:', baseWidth, '像素');
        console.log('页面swiper高度更新为:', app.swiper_height, '像素');
      },

      init_video() {
        let app = this;

        //判断后缀是啥文件支持m3u8，flv以及mp4格式的
        let url = app.config_info.theme1_top_video;
        // 检查 url 是否为空或 null
        if (!url) {
          console.log("url", url);
          console.error('URL is empty or null');
          return;
        }

        const fileName = url.substring(url.lastIndexOf('/') + 1);
        const fileExtension = fileName.substring(fileName.lastIndexOf('.') + 1);
        if (fileExtension === 'm3u8') {
          console.log('文件名后缀是.m3u8');
          app.is_m3u8 = 1;
        } else if (fileExtension === 'flv') {
          console.log('文件名后缀是.flv');
          app.is_m3u8 = 0;
        } else {
          console.log('文件名后缀是.' + fileExtension);
          app.is_m3u8 = 0;
        }

        console.log('是否支持HLS', Hls.isSupported())
        console.log('浏览器信息, window.navigator.userAgent: ', window.navigator.userAgent);

        app.hls = new Hls()
        console.log("url1", url);
        app.hls.loadSource(url)
        //app.poster = app.gooodinfo.goods_thumb;
        app.hls.attachMedia(app.$refs.video)
        app.hls.on(Hls.Events.MANIFEST_PARSED, function() {
          app.$refs.video.play();
        })

        app.hls.on(Hls.Events.ERROR, (event, data) => {
          console.log(event, data);
          // 监听出错事件
        })



      },
      // 停止流
      videoPause() {
        let app = this;
        if (app.hls) {
          app.hls.destroy();
          app.hls = null;
        }
      },

      // 页面初始化
      initShow() {
        const app = this;
        //画册的id
        var id = this.$route.query.id;
        app.huace_id = id;

        //会员的token
        var token = localStorage.getItem("token");
        this.$http
          .get(api_url + "action=get_config&id=" + id+"&host="+window.location.hostname)
          .then((res) => {
            if (res.data.sta != "200") {
              return;
            }

            //获取所有后台返回的样式
            this.config_info = res.data.res;

            //如果开启购物车模式的话获取购物车信息
            if (app.config_info.is_show_fangan_cart == '1') {
              app.getCartInfo();
            }

            //设置左侧栏默认字体大小
            if (this.config_info.left_font_size == null) {
              this.config_info.left_font_size = "14px";
            }
            //设置二级菜单默认背景色
            if (this.config_info.right_erji_background_color == null) {
              this.config_info.right_erji_background_color = "#fff";
            }
            //设置二级菜单默认字体颜色
            if (this.config_info.right_erji_font_color == null) {
              this.config_info.right_erji_font_color = "yellow";
            }
            //设置二级菜单默认宽度
            if (this.config_info.right_erji_border_width == null) {
              this.config_info.right_erji_border_width = "0";
            }
            this.check = {
              "--check_bg_color": res.data.res.left_background_check_color ?
                res.data.res.left_background_check_color : "#a4def2",
              "--check_bg_color1": res.data.res.left_background_check_color1 ?
                res.data.res.left_background_check_color1 : "#fff",
              "--new_font_color": res.data.res.left_font_checked_color ?
                res.data.res.left_font_checked_color : "#A50610",
              "--new_height": res.data.res.left_height ?
                res.data.res.left_height : "3.6rem"
            };
            this.no_check = {
              "--bg_color": res.data.res.left_background_color ?
                res.data.res.left_background_color : "#fff",
              "--new_font_color": res.data.res.left_font_color ?
                res.data.res.left_font_color : "#a4def2",
              "--new_height": res.data.res.left_height ?
                res.data.res.left_height : "3.6rem"
            };

            this.right_erji_btn_check = {
              "--right_btn_check_bg_color": res.data.res.right_erji_btn_background_check_color ?
                res.data.res.right_erji_btn_background_check_color : "#ff5f00",
              "--right_btn_bg_color": res.data.res.right_erji_btn_background_color ?
                res.data.res.right_erji_btn_background_color : "#fff",
              "--right_erji_font_color": res.data.res.right_erji_font_color ?
                res.data.res.right_erji_font_color : "#000",
              "--right_erji_border_width": res.data.res.right_erji_border_width ?
                `0 ${res.data.res.right_erji_border_width}` : "0 1px",
            };
            this.right_erji_btn_no_check = {
              "--right_btn_check_bg_color": res.data.res.right_erji_btn_background_check_color ?
                res.data.res.right_erji_btn_background_check_color : "#ff5f00",
              "--right_btn_bg_color": res.data.res.right_erji_btn_background_color ?
                res.data.res.right_erji_btn_background_color : "#fff",
              "--right_erji_font_color": res.data.res.right_erji_font_color ?
                res.data.res.right_erji_font_color : "#000",
              "--right_erji_border_width": res.data.res.right_erji_border_width ?
                `0 ${res.data.res.right_erji_border_width}` : "0 1px",
            };

            //是否显示加入采购蓝
            let cart_btn_height = 0;
            if (res.data.res.is_show_fangan_cart == 1) {
              cart_btn_height = 20;
            } else {
              cart_btn_height = 0;
            }

            //绑定全局css变量,对于固定的变量可以写这里
            this.box = {
              "--left_nav_first_margin_top": res.data.res.left_nav_first_margin_top ?
                res.data.res.left_nav_first_margin_top : res.data.res.left_nav_margin_px,
              "--good_box_height": `${Number((res.data.res.default_good_box_height || "200").toString().replace(/px/g, '')) + (Number(cart_btn_height) || 0)}px`

            };

            this.id = res.data.res.id;
            let theme_id = res.data.res.id;

            //横纵比例
            let theme1_top_carousel_bili = res.data.res.theme1_top_carousel_bili;
            app.updateTop1Height(theme1_top_carousel_bili);
            // 当窗口大小改变时重新获取
            window.addEventListener('resize', function() {
              app.updateTop1Height(theme1_top_carousel_bili);
            });

            //给总高度赋值,默认100vh，有些banner图片很高的就自行后台设置吧。
            app.total_height = res.data.res.total_height;
            //默认否0，如果开启后，选中左侧分类分享给别人，别人打开后默认选中第一个分类，以及展示第一个分类的产品。
            app.is_fx_after_always_show_left_first_nav = res.data.res.is_fx_after_always_show_left_first_nav;
            //二级分类是否显示全部
            app.is_second_classify_show_all = res.data.res.is_second_classify_show_all;

            //轮播图高度初始化
            //app.swiper_height = window.innerWidth / res.data.res.theme1_top_carousel_bili;
            //console.log("横纵比例", res.data.res.theme1_top_carousel_bili)
            //console.log("window.innerWidth", window.innerWidth)
            //console.log("轮播图计算后的高度", app.swiper_height)
            /*改成flex布局这块废弃了
              //是否有联系人，联系电话，如果有多减去
              let config_info = res.data.res;
              if (config_info.share_type != 1) {
                if (!!config_info.company == true || !!config_info.linkman == true || !!config_info.linktel == true) {
                  app.left1_height = `calc(100vh - ${app.swiper_height}px - 46px)`;
                  app.right1_height = `calc(100vh - ${app.swiper_height}px - 46px)`;
                  console.log("left1_height", app.left1_height);
                  console.log("right1_height", app.right1_height);
                } else {
                  app.left1_height = `calc(100vh - ${app.swiper_height}px )`;
                  app.right1_height = `calc(100vh - ${app.swiper_height}px)`;
                  console.log("left1_height", app.left1_height);
                  console.log("right1_height", app.right1_height);
                }
              } else if (config_info.share_type == 1) {
              app.left1_height = `calc(100vh - ${app.swiper_height}px - 46px)`;
              app.right1_height = `calc(100vh - ${app.swiper_height}px - 46px)`;
              console.log("left1_height", app.left1_height);
              console.log("right1_height", app.right1_height);
            }
            */



            this.$http
              .get(
                api_url +
                "action=get_classify&theme_id=" +
                theme_id +
                "&token=" +
                token
              )
              .then((res) => {

                //左侧一级分类列表
                app.catList = res.data.res;
                app.is_loading = false;

                //初始化视频，增加延迟加载功能
                setTimeout(function() {
                  app.init_video()
                }, 0)



                var cat_id = this.$route.query.cat_id;

                //onload首次加载，如果cat_id不存在或者说后台模板开启了分享后默认打开第一个分类
                if (typeof(cat_id) == 'undefined' || app.is_fx_after_always_show_left_first_nav == '1') {
                  app.getList(app.catList[0].id, app.catList[0].type, 0);
                } else {
                  //app.getList(app.catList[0].id, app.catList[0].type, 0);

                  let found = false; // 初始化标志变量，表示是否找到了匹配的item
                  app.catList.forEach((item, index) => {

                    if (item.id == cat_id) {
                      console.log("分类找到了，默认get到的分类id", item.id);
                      app.getList(item.id, item.type, index);
                      found = true; // 如果找到了匹配项，设置标志为true
                      return;
                    }
                  });
                  // 循环结束后检查标志变量
                  if (!found) { // 如果循环里没有执行过getList，即没找到匹配项
                    console.log("分类被删除了，默认成第一个");
                    app.getList(app.catList[0].id, app.catList[0].type, 0);
                    return;
                  }


                }

              });
          });


      },

      getCartInfo() {
        let app = this;
        var token = localStorage.getItem("token");
        let huace_id = this.$route.query.id;
        this.$http
          .get(api_url + `action=get_cart_info&id=${huace_id}&token=${token}`)
          .then((res) => {
            console.log(res.data);
            if (res.data.sta == '200') {
              console.log("res.data.countall", res.data.countall);
              app.cart_list = res.data.data;
              app.countall = res.data.countall;
              app.countall_name = res.data.countall_name;
              app.countgou = res.data.countgou;
            }
          })
          .catch((error) => {
            console.error("请求失败:", error);
          })
          .finally(() => {});
      },
      // 获取菜单分类列表
      getList(cat_id, type, index) {

        this.cat_id = cat_id;
        this.type1 = type;
        let app = this;
        let huace_id = app.huace_id;

        /*点击的时候处理顶部的路由改变*/
        this.$router.replace({
          path: this.$route.path,
          query: {
            ...this.$route.query,
            cat_id: this.cat_id
          }
        });
        //重置分享
        app.wechatShare()

        Toast.loading({
          message: "加载中...",
          forbidClick: true,
        });
        this.leftcolordisplay = index;
        //渲染颜色
        var token = localStorage.getItem("token");

        if (type == "商品列表") {
          this.type = 1;
          this.$http
            .get(
              api_url +
              `action=get_goodlist&classify_id=${cat_id}&token=${token}&id=${huace_id}`
            )
            .then((res) => {
              console.log("商品列表", res, this.type);

              //选择分类信息
              this.good_classify_info = res.data.good_classify_info;

              //获取二级菜单列表
              this.diyigelist = res.data.res1;
              if (this.diyigelist == "") {
                this.erji = false;
              } else {
                this.erji = true;
                /*
                document.querySelectorAll(".erjifen-item").forEach((lin) => {
                  if ((lin.classList.value = "erjifen-item erjifenactive")) {
                    lin.classList.remove("erjifenactive");
                  }
                });
                */
                //二级分类里面的全部选中
                this.righterjicolordisplay = -1;
              }


              if (this.diyigelist.length > 8) {
                this.xianshi = true;
                this.diyigelist.length = 6;
                this.zhuangtai = 0;
              } else {
                this.xianshi = false;
                this.zhuangtai = 1;
              }


              //二级分类是否显示全部,不显示的话，则选中第一个
              let is_second_classify_show_all = app.is_second_classify_show_all;
              if (app.erji == true && is_second_classify_show_all != '1') {
                console.log("getListone", app.diyigelist[0]['id']);
                app.getListone(0, app.diyigelist[0]['id']);
                return;
              } else {
                this.$refs.right1.scrollTop = 0;
                this.goods = res.data.res;
                this.goods1 = [];
                this.goods2 = [];
                this.goods3 = [];

                this.quan = true;
                Toast.clear();
              }


            });
        } else if (type == "多图展示") {
          this.type = 2;
          //先置空然后就滑倒顶部了
          this.goods1=[];
          this.$http
            .get(
              api_url +
              `action=get_goodlist&classify_id=${cat_id}&token=${token}&id=${huace_id}`
            )
            .then((res) => {
              console.log("多图展示", res, this.type);
              this.goods1 = res.data.res;
              this.goods = [];
              this.goods2 = [];
              this.goods3 = [];
              Toast.clear();
            });
        } else if (type == "文件下载") {
          this.type = 3;
          this.$http
            .get(
              api_url +
              `action=get_goodlist&classify_id=${cat_id}&token=${token}&id=${huace_id}`
            )
            .then((res) => {
              console.log("文件下载", res, this.type);
              this.goods2 = res.data.res;
              this.goods1 = [];
              this.goods = [];
              this.goods3 = [];
              Toast.clear();
            });
        } else if (type == "礼品册") {
          this.type = 4;
          this.$http
            .get(
              api_url + `action=getGiftListByCategoryID&id=${cat_id}&token=${token}`
            )
            .then((res) => {
              console.log("礼品册", res, this.type);
              this.goods3 = res.data.res;
              this.goods1 = [];
              this.goods2 = [];
              this.goods = [];
              Toast.clear();
            })
        }
      },
      // 获取二级菜单下面的子菜单
      getListone(index, id) {
        console.log("getListone");
        if (this.quan == true) {
          this.quan = false;
        }

        /*
        document.querySelectorAll(".erjifen-item").forEach((lin) => {
          if ((lin.classList.value = "erjifen-item erjifenactive")) {
            lin.classList.remove("erjifenactive");
          }
        });
        document.querySelectorAll(".erjifen-item")[index].classList.add("erjifenactive");
        */

        //二级分类里面的第几个选中
        this.righterjicolordisplay = index;

        Toast.loading({
          message: "加载中...",
          forbidClick: true,
        });
        var token = localStorage.getItem("token");
        if (this.type1 == "商品列表") {
          this.type = 1;
          this.$http
            .get(
              api_url +
              `action=get_goodlist&classify_id=${id}&token=${token}&id=${this.huace_id}`
            )
            .then((res) => {
              this.goods = res.data.res;
              Toast.clear();
            });
        } else if (type == "多图展示") {
          this.type = 2;
          this.$http
            .get(
              api_url +
              `action=get_goodlist&classify_id=${id}&token=${token}&id=${this.huace_id}`
            )
            .then((res) => {
              this.goods1 = res.data.res;
              Toast.clear();
            });
        } else if (type == "文件下载") {
          this.type = 3;
          this.$http
            .get(
              api_url +
              `action=get_goodlist&classify_id=${id}&token=${token}&id=${this.huace_id}`
            )
            .then((res) => {
              this.goods2 = res.data.res;
              Toast.clear();
            });
        }
      },
      //点击二级分类的全部
      getListall() {
        console.log("getListall");
        this.quan = !this.quan;

        /*
        document.querySelectorAll(".erjifen-item").forEach((lin) => {
          if ((lin.classList.value = "erjifen-item erjifenactive")) {
            lin.classList.remove("erjifenactive");
          }
        });
        */
        //二级分类里面的全部选中
        this.righterjicolordisplay = -1;

        Toast.loading({
          message: "加载中...",
          forbidClick: true,
        });
        var token = localStorage.getItem("token");
        if (this.type1 == "商品列表") {
          this.type = 1;
          this.$http
            .get(
              api_url +
              `action=get_goodlist&classify_id=${this.cat_id}&token=${token}&id=${this.huace_id}`
            )
            .then((res) => {
              //获取二级菜单列表
              this.diyigelist = res.data.res1;
              if (this.diyigelist == "") {
                this.erji = false;
              } else {
                this.erji = true;
              }
              if (this.diyigelist.length > 8) {
                this.xianshi = true;
                this.diyigelist.length = 6;
              } else {
                this.xianshi = false;

              }

              this.$refs.right1.scrollTop = 0;
              this.goods = res.data.res;
              Toast.clear();
            });
        } else if (type == "多图展示") {
          this.type = 2;
          this.$http
            .get(
              api_url +
              `action=get_goodlist&classify_id=${this.cat_id}&token=${token}&id=${this.huace_id}`
            )
            .then((res) => {
              this.goods1 = res.data.res;
              Toast.clear();
            });
        } else if (type == "文件下载") {
          this.type = 3;
          this.$http
            .get(
              api_url +
              `action=get_goodlist&classify_id=${this.cat_id}&token=${token}&id=${this.huace_id}`
            )
            .then((res) => {
              this.goods2 = res.data.res;
              Toast.clear();
            });
        }
      },
      // 二级菜单展开
      zhankai() {
        this.zhuangtai = 1;
        var token = localStorage.getItem("token");
        if (this.type1 == "商品列表") {
          this.type = 1;
          this.$http
            .get(
              api_url +
              `action=get_goodlist&classify_id=${this.cat_id}&token=${token}&id=${this.huace_id}`
            )
            .then((res) => {
              //获取二级菜单列表
              this.diyigelist = res.data.res1;
              if (this.diyigelist == "") {
                this.erji = false;
              } else {
                this.erji = true;
              }

              this.$refs.right1.scrollTop = 0;
              this.goods = res.data.res;
            });
        } else if (this.type1 == "多图展示") {
          this.type = 2;
          this.$http
            .get(
              api_url +
              `action=get_goodlist&classify_id=${this.cat_id}&token=${token}&id=${this.huace_id}`
            )
            .then((res) => {
              this.goods1 = res.data.res;
              Toast.clear();
            });
        } else if (this.type1 == "文件下载") {
          this.type = 3;
          this.$http
            .get(
              api_url +
              `action=get_goodlist&classify_id=${this.cat_id}&token=${token}&id=${this.huace_id}`
            )
            .then((res) => {
              this.goods2 = res.data.res;
              Toast.clear();
            });
        }
      },
      // 二级菜单收起
      shouqi() {
        this.zhuangtai = 0;
        this.diyigelist.length = 6;
      },
      // 跳转详情页
      navGoodDetail(item) {
        const goods_id = item.id;
        const outUrl = item.out_url ? String(item.out_url).trim() : "";
        if (this.config_info.is_good_list_jump_out_url == "1" && outUrl) {
          window.location.href = outUrl;
          return;
        }
        //id是画册的id
        var id = this.$route.query.id;
        this.$router.push({
          path: "/detail",
          query: {
            id: id,
            goods_id: goods_id,
          },
        });
      },
      // 添加到方案车
      // 多图展示：配置了外链时仅在 H5 端跳转，未配置则保持纯图片展示。
      navMultiImage(item) {
        const outUrl = item && item.out_url ? String(item.out_url).trim() : "";
        if (outUrl) {
          window.location.href = outUrl;
        }
      },
      addFanganCart(good_id) {
        let app = this;
        // id是画册的id
        var id = this.$route.query.id;
        console.log("添加到方案车good_id:", good_id);
        Toast.loading({
          message: "加载中...",
          forbidClick: true,
        });
        setTimeout(() => {
          var token = localStorage.getItem("token");

          this.$http
            .get(
              api_url + `action=add_to_cart&good_id=${good_id}&token=${token}&id=${id}`
            )
            .then((res) => {
              console.log(res.data);
              // 成功和失败都提示下，然后关闭弹层
              if (res.data.sta === '200') {
                Toast({
                  message: res.data.msg || '添加成功',
                  duration: 2000,
                  icon: 'success'
                });

                //获取购物车信息
                app.getCartInfo();

              } else {
                Toast({
                  message: res.data.msg || '添加失败，请重试',
                  duration: 2000,
                  type: 'fail'
                });
              }
            })
            .catch((error) => {
              console.error("请求失败:", error);
              Toast({
                message: '网络请求失败，请检查您的网络连接',
                duration: 2000,
                type: 'fail'
              });
            })
            .finally(() => {
              // 无论成功还是失败，都关闭加载提示
              //Toast.clear();
            });

        }, 500);
      },
      // 跳转方案车页
      goFanganCart() {
        //id是画册的id
        var id = this.$route.query.id;
        this.$router.push({
          path: "/fangancart",
          query: {
            id: id
          },
        });
      },

      // 跳转shop页
      goshop(gift_id) {
        //id是画册的id
        var id = this.$route.query.id;
        this.$router.push({
          path: "/shop",
          query: {
            id: id,
            gift_id: gift_id
          },
        });
      },
      // 获取我的链接事件
      shenglian() {
        this.lay = 1;
      },
      //关闭我的链接窗口
      guanbi() {
        this.lay = 0;
      },
      //提交我的链接事件
      tijiao_old() {
        var app = this;
        if (this.phone.length != 11) {
          this.phonetrue = true
        } else {
          this.phonetrue = false
        }
        if (this.gongsi == '') {
          this.gongsitrue = true
        } else {
          this.gongsitrue = false
        }
        if (this.name == '') {
          this.nametrue = true
        } else {
          this.nametrue = false
        }
        if (this.phone.length == 11 && this.gongsi != '' && this.name != '') {

          this.$http
            .post(
              api_url +
              "action=generatePersonalLink&old_id=" + this.huace_id + "&linkman=" + this.name + "&phone=" + this.phone +
              "&company=" + this.gongsi
            )
            .then((res) => {
              // 更新状态
              app.lay = 0;
              app.huace_id = res.data.data.id;
              // 更新路由查询参数
              app.$router.replace({
                query: {
                  id: this.huace_id,
                  cat_id: this.cat_id
                }
              });
              // 如果需要重新初始化显示，可以在更新路由后执行
              app.initShow();
              app.wechatShare();

            }).catch((error) => {
              console.error('There was an error generating the personal link!', error);
            });
        }
      },
      tijiao() {
        const app = this;
        app.phonetrue = app.phone.length !== 11;
        app.gongsitrue = app.gongsi === '';
        app.nametrue = app.name === '';
        app.shareTitleTrue = app.isCustomShare && app.shareTitle === '';
        app.shareDescTrue = app.isCustomShare && app.shareDesc === '';

        if (
          !app.phonetrue &&
          !app.gongsitrue &&
          !app.nametrue &&
          (!app.isCustomShare || (!app.shareTitleTrue && !app.shareDescTrue))
        ) {
          let url =
            `${api_url}action=generatePersonalLink&old_id=${app.huace_id}&linkman=${app.name}&phone=${app.phone}&company=${app.gongsi}`;
          const customShareFlag = app.isCustomShare ? 1 : 0;
          url +=
            `&isCustomShare=${encodeURIComponent(customShareFlag)}&shareTitle=${encodeURIComponent(app.shareTitle)}&shareDesc=${encodeURIComponent(app.shareDesc)}`;


          app.$http.post(url)
            .then((res) => {
              app.lay = 0;
              app.huace_id = res.data.data.id;
              app.$router.replace({
                query: {
                  id: app.huace_id,
                  cat_id: app.cat_id
                }
              });
              app.initShow();
              app.wechatShare();
            })
            .catch((error) => {
              console.error('There was an error generating the personal link!', error);
            });
        }
      },
      // //文件下载
      downLoadFile(link_url, file_id) {
        //调用日志记录接口
        var id = this.$route.query.id;
        var token = localStorage.getItem("token");
        var app = this;
        var pathUrl =
          api_url +
          `action=add_download_log&id=${id}&token=${token}&link_url=${link_url}&file_id=${file_id}`;
        this.$http
          .request({
              url: pathUrl,
            },
            "GET"
          )
          .then((res) => {
            let a = document.createElement("a");
            a.href = link_url;
            a.click();
          });
      },
      //微信分享
      wechatShare() {
        var id = this.$route.query.id;
        var token = localStorage.getItem("token");
        var app = this;
        var shareLink = getCurrentRouteUrl(this.$route);
        //必须要url编码，如果不变吗，url的参数值里面有&拼接会被当做接口参数以及参数值，再次发送
        let url = encodeURIComponent(window.location.href);
        var pathUrl =
          api_url + `action=get_wxshare_param&id=${id}&token=${token}&url=${url}`;
        this.$http
          .request({
              url: pathUrl,
            },
            "GET"
          )
          .then((res) => {
            // console.log("get_wxshare_param", res);
            if (res.data.sta == 200) {
              let data = res.data;

              //设置网页标题
              document.title = res.data.res.share_title;




              //通过config接口注入权限验证配置
              wx.config({
                debug: data.res.is_debug_fx,
                appId: data.res.appId,
                timestamp: data.res.timestamp,
                nonceStr: data.res.nonceStr,
                signature: data.res.signature,
                jsApiList: [
                  "updateTimelineShareData",
                  "updateAppMessageShareData",
                  "showAllNonBaseMenuItem",
                  "hideAllNonBaseMenuItem",
                  "showMenuItems",
                  "onMenuShareAppMessage",
                  "onMenuShareTimeline",
                ],
              });
              //console.log(data.res.appId)
              //console.log(data.res.timestamp)
              //console.log(data.res.nonceStr)
              //console.log(data.res.signature)

              //通过ready接口处理成功验证
              wx.ready(function() {
                //展示所有基础类型按钮，20211012日，微信增加了直接访问网址，出现一个拦截，这种情况下不显示分享按钮，先收藏然后在分享就可以，bug
                wx.showAllNonBaseMenuItem();
                /*
                wx.hideAllNonBaseMenuItem();
                wx.showMenuItems({
                  menuList: ["menuItem:share:appMessage", "menuItem:share:timeline",
                    "updateAppMessageShareData", "updateAppMessageShareData"
                  ] // 要显示的菜单项，所有menu项见附录3
                });*/
                /*
                //注释掉新版，旧的才会生效
                wx.updateAppMessageShareData({
                  title: data.res.share_title,
                  desc: data.res.share_desc,
                  link: shareLink,
                  //link: "http://www.baidu.com",
                  imgUrl: data.res.share_img,
                  success: function() {
                    console.log("设置成功1")
                  },
                  cancel: function(res) {
                    console.log('分享失败1');
                  },
                  complete: function(res) {
                    console.log("complete1");
                  },
                  trigger: function(res) {
                    console.log("trigger1");
                  }
                })
                wx.updateTimelineShareData({
                  title: data.res.share_title,
                  desc: data.res.share_desc,
                  link: shareLink,
                  //link: "http://xiu.lizengtong.com/index.php?id=600",
                  imgUrl: data.res.share_img,
                  success: function(res) {
                    console.log('设置成功2');
                  },
                  cancel: function(res) {
                    console.log('分享失败2');
                  },
                  complete: function(res) {
                    console.log("complete2");
                  },
                  trigger: function(res) {
                    console.log("trigger2");
                  }
                });
                */
                //旧的版本还有分享成功回调。不过不知道能用多久还
                wx.onMenuShareAppMessage({
                  title: data.res.share_title, // 分享标题
                  desc: data.res.share_desc, // 分享描述
                  link: shareLink, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                  imgUrl: data.res.share_img, // 分享图标
                  type: "", // 分享类型,music、video或link，不填默认为link
                  dataUrl: "", // 如果type是music或video，则要提供数据链接，默认为空
                  success: function() {
                    // 用户点击了分享后执行的回调函数
                    //alert("分享执行成功了1")
                    var link = escape(shareLink);
                    var desc = data.res.share_desc;
                    var title = data.res.share_title;
                    var imgUrl = data.res.share_img;
                    var share_type = "1";
                    var pathUrl =
                      api_url +
                      `action=notify_share_success&id=${id}&token=${token}&link=${link}&desc=${desc}&title=${title}&imgUrl=${imgUrl}&share_type=${share_type}`;
                    app.$http
                      .request({
                          url: pathUrl,
                        },
                        "GET"
                      )
                      .then((res) => {
                        console.log("notify_share_success", res);
                      });
                  },
                });
                wx.onMenuShareTimeline({
                  title: data.res.share_title, // 分享标题
                  link: shareLink, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                  imgUrl: data.res.share_img, // 分享图标
                  success: function() {
                    // 用户点击了分享后执行的回调函数
                    //alert("分享执行成功了2")
                    var link = escape(shareLink);
                    var desc = "";
                    var title = data.res.share_title;
                    var imgUrl = data.res.share_img;
                    var share_type = "2";
                    var pathUrl =
                      api_url +
                      `action=notify_share_success&id=${id}&token=${token}&link=${link}&desc=${desc}&title=${title}&imgUrl=${imgUrl}&share_type=${share_type}`;
                    app.$http
                      .request({
                          url: pathUrl,
                        },
                        "GET"
                      )
                      .then((res) => {
                        console.log("notify_share_success", res);
                      });
                  },
                });
              });
            }
          });
      },
      // 复制成功时的回调函数
      onCopy(e) {
        Toast.success("内容已复制到剪切板");
      },
      copy_log(link_url, file_id) {
        //调用日志记录接口
        var id = this.$route.query.id;
        var token = localStorage.getItem("token");
        var app = this;
        var pathUrl =
          api_url +
          `action=add_copy_log&id=${id}&token=${token}&link_url=${link_url}&file_id=${file_id}`;
        this.$http
          .request({
              url: pathUrl,
            },
            "GET"
          )
          .then((res) => {});
      },
      // 复制失败时的回调函数
      onError(e) {
        Toast.fail("抱歉，复制失败！");
      },
      scroll_left(e) {
        let scroll_left1 = this.$refs.left1.scrollTop;
        //console.log("scroll_left1", scroll_left1);
        //存储 scrollTop 的值
        this.scroll_left1 = scroll_left1;

      },
      scroll_right() {
        let scroll_right1 = this.$refs.right1.scrollTop;
        //存储 scrollTop 的值
        this.scroll_right1 = scroll_right1;
      },
      scrollToFeatureSection(cat_id) {
        // 使用document.querySelector获取锚点元素
        //禁止滑动
        //如果高度是100vh是可以滑动的，其他的不可以
        return;
        const featureSection = document.querySelector('#cat' + cat_id);
        console.log("锚点滑动", featureSection);
        // 检查锚点元素是否存在
        if (featureSection) {
          // 使用scrollIntoView平滑滚动到锚点
          featureSection.scrollIntoView({
            behavior: 'smooth'
          });
        }
      }

    },
    created() {
      //初始化
      this.initShow();
    },
    mounted() {


    },
    beforeDestroy() {
      let app = this;
      // 清理监听，避免内存泄漏
      window.removeEventListener('resize', app.updateTop1Height);
    },
    updated() {
      let app = this;
      // 确保DOM已经渲染完成再执行滚动操作
      setTimeout(() => {
        console.log('开始滑动默认分类');
        // 这里放置你想在5秒后执行的代码
        let index = app.leftcolordisplay;
        console.log("左侧菜单选中第几个：", index);
        //左侧菜单超过多少个才滑动
        if (index >= 0) {
          app.scrollToFeatureSection(app.cat_id);
        }
      }, 0); // 5000毫秒等于5秒
    },
    activated() {
      //微信分享，第一次加载执行created和activated，但是从详情页面切换回来，只能执行activated，所以，分享内容重置以及title改变放到这里面
      this.wechatShare();
      if (this.$refs.left1) {
        this.$refs.left1.scrollTop = this.scroll_left1;
        this.$refs.right1.scrollTop = this.scroll_right1;
      }

      let app = this;
      //如果开启购物车模式的话获取购物车信息
      if (app.config_info.is_show_fangan_cart == '1') {
        app.getCartInfo();
      }
    }
  };
</script>

<style scoped="scoped">
  .icon_no_check {
    background-color: none;
    /*4改成6*/
    width: 6px;
    /*56改成70*/
    height: 95%;
    background: transparent;
    border-radius: 2px 2px 2px 2px;
  }

  .icon_check {
    background-color: var(--new_font_color) !important;
    width: 6px;
    height: 95%;
    background: transparent;
    border-radius: 2px 2px 2px 2px;
  }

  .navs {
    background-color: var(--check_bg_color1);
  }

  .nav:first-child {
    margin-top: var(--left_nav_first_margin_top) !important;
  }

  .left_item_icon {
    width: 4px;
    height: 56px;
    background: transparent;
    border-radius: 2px 2px 2px 2px;
  }



  .fangan_cart .badge {
    position: absolute;
    /* 绝对定位，相对于父元素 .fangan_cart */
    top: -5px;
    /* 顶部对齐 */
    right: -5px;
    /* 右边对齐 */
    background-color: red;
    color: white;
    font-size: 9px !important;
    width: 25px;
    height: 25px;
    border-radius: 50%;
    /* 圆形 */
    display: flex;
    align-items: center;
    justify-content: center;
    line-height: 15px;
    /* 使文字垂直居中 */
  }


  /**品牌认证开始**/
  .brand_cert {
    position: fixed;
    top: 0;
    right: 0;
    /*width: 3rem;*/
    height: 1.8rem;
    line-height: 1.8rem;
    border-radius: 50%;
    background: #fff;
  }

  .brand_cert img {
    width: 99%;
    height: 99%;
  }

  /**品牌认证结束**/

  /**方案cart开始**/
  .fangan_cart {
    position: fixed;
    bottom: 4.625rem;
    right: 0.625rem;
    width: 2.5rem;
    height: 2.5rem;
    line-height: 2.5rem;
    border-radius: 50%;
    background: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .fangan_cart img {
    width: 60%;
    height: 60%;
  }

  /**方案cart结束**/


  /**品牌认证和采购篮开始**/
  .brand_cert_fangan_cart {
    position: fixed;
    top: 80px;
    right: 0;
    height: 1.8rem;
    line-height: 1.8rem;
    border-radius: 50%;
    background: #fff;
    display: flex;
    flex-direction: column;
  }

  .brand_cert_fangan_cart img {
    width: 100px;
    height: auto;
  }

  /**品牌认证和采购篮开始结束**/



  .box {
    display: flex;
    flex-direction: column;
  }

  .web-player-wrapper {
    background: black;
    width: 100%;
    height: auto;
  }

  #player {
    height: auto !important;
  }



  .erjifenlei {
    width: 89%;
    height: auto;
    margin: 0;
    margin-left: 0.6rem;
    display: flex;
    flex-wrap: wrap;
    box-sizing: border-box;
    padding-top: 20px;
    padding-bottom: 15px;
    background: skyblue;
    overflow: hidden;
    box-sizing: border-box;
    border-radius: 8px;
  }

  .erjifen {
    width: 33%;
    height: auto;
    margin-bottom: 7px;
  }

  .erjifen-item {
    width: 85%;
    min-height: 42px;
    margin: auto;
    font-size: 11px;
    text-align: center;
    line-height: 1.2;
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    color: var(--right_erji_font_color);
    background: var(--right_btn_bg_color);
    /*border: 1px solid #000;*/
    cursor: pointer;
    border-radius: 8px;
    overflow: hidden;
    padding: 4px 4px;
    word-break: break-all;
    overflow-wrap: anywhere;
    border: 0.0625rem solid #b0b6bd;

  }

  .erjifenlei .erjifen .erjifen-item:hover {
    color: var(--right_erji_font_color);
    background: var(--right_btn_check_bg_color);
    /*
    border: 1px solid #fff;
    */
    padding: var(--right_erji_border_width);
  }

  .erjifen-item.erjifenactive {
    background: var(--right_btn_check_bg_color);
    color: var(--right_erji_font_color);
    /*
     border: 1px solid #fff;
     */
    border: none !important;
    padding: var(--right_erji_border_width);
  }

  .erjifen1 {
    width: 33%;
    height: auto;
    margin-bottom: 7px;
  }

  .erjifen1-item {
    width: 85%;
    min-height: 42px;
    margin: auto;
    font-size: 11px;
    text-align: center;
    line-height: 1.2;
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    color: var(--right_erji_font_color);
    background: var(--right_btn_bg_color);
    /*border: 1px solid #000;*/
    cursor: pointer;
    border-radius: 8px;
    overflow: hidden;
    padding: 4px 4px;
    word-break: break-all;
    overflow-wrap: anywhere;
    border: 0.0625rem solid #b0b6bd;
  }

  .erjifenlei .erjifen1 .erjifen1-item:hover {
    color: var(--right_erji_font_color);
    background: var(--right_btn_check_bg_color);
    /*border: 1px solid #fff;*/
    padding: var(--right_erji_border_width);
  }

  .erjifen1-item.erjifen1active {
    color: var(--right_erji_font_color);
    background: var(--right_btn_check_bg_color);
    /*border: 1px solid #fff;*/
    padding: var(--right_erji_border_width);
    border: none !important;
  }

  .erjizhanshi {
    width: 98%;
    height: 30px;
    line-height: 30px;
    text-align: center;
    cursor: pointer;
  }

  /*商品名字默认值*/
  .good_name {
    color: black;
    font-size: 12px;
    font-weight: 400;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    max-height: 40px;
    /*height:40px;*/
    line-height: 20px;
    overflow: hidden;
  }

  /*商品价格默认值*/
  .good_price {
    display: inline-block;
    color: black;
    font-size: 14px;
    font-weight: 400;
  }

  .top1 img {
    width: 100%;
  }

  .top1 .address {
    width: 100%;
    height: 36px;
    line-height: 36px;
    background-color: #f2f2f2;
    display: flex;
    justify-content: space-around;
    /*margin-top: -0.1875rem;*/
    font-size: 0.625rem;
    padding-top: 5px;
    padding-bottom: 5px;
  }

  .bottom1 {
    width: 100%;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    margin-top: 0rem;
    /*padding-bottom: 40px;*/
  }

  .bottom1 .left1 {
    width: 26%;
    /* background-color:#00982E; */
    /* overflow: scroll; */
    margin-top: 0rem;
    background-color: #fff;
    display: block;
    /*    justify-content: center;
    flex-wrap: wrap; */
    margin-left: 0rem;
    /* height: 35rem; */
    /*height: calc(100vh - 210px);*/
    overflow: hidden;
    overflow-y: scroll;
  }

  .left1 .nav {
    width: 95%;
    /*margin: -0.3125rem auto;*/
    height: var(--new_height);
  }

  .left1 .cate1 {
    background-color: var(--bg_color);
    color: var(--new_font_color);
    height: 100%;
    width: 95%;
    /* //height: 3.6rem; */
    display: flex;
    justify-content: space-around;
    align-items: center;
    border: 0.0625rem solid #b0b6bd;
    border-radius: 10px;
    /*margin-bottom: 0.3rem;*/
    /* margin-left: 0.625rem; */
    /* color: #a4def2; */
    /* font-weight: bold; */
    font-family: "微软雅黑";
  }

  .left1 .leftcolorchange {
    /*background-color: #a4def2 !important;*/
    background-color: var(--check_bg_color);
    color: var(--new_font_color);
    height: 100%;
    border-radius: 10px;
    border: none !important;
    font-weight: 550;
  }

  /* 通过hover的方式废弃，因为点击别的空白区域取消选中，页面第一次打开默认第一个选中也无法实现 */
  /* .cate1:hover {
    background-color: #a4def2 !important;
    border-radius: 10px;
    border: none !important;
  } */

  .bottom1 .right1 {
    width: 73%;
    overflow: hidden;
    overflow-y: scroll;
    display: flex;
    flex-direction: column;
    justify-self: flex-start;
    margin: 0 auto;
  }

  .bottom1 .right1 .right_good_list {
    margin: 0 auto;
    width: 100%;
    padding: 0 5%;
    box-sizing: border-box;
    /*margin-top: 4px;*/
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-between;
  }

  .right1 .goods {
    width: 49%;
    height: var(--good_box_height);
    margin-top: 0.6875rem;
  }


  .right1 .goods dt {
    height: 7rem;
    display: flex;
    justify-content: center;
    align-items: center;
    /*border: 0.0625rem solid #a4def2;*/
    /*border-radius: 15px;*/
    border: 1px solid #b6b6b6;
    border-radius: 5px;
    margin-top: 1.75rem;
    width: 6.6rem;
    height: 6.6rem;
    margin: 0 auto;
  }

  .right1 .goods dt img {
    width: 6.5rem;
    height: 6.5rem;
  }

  .right1 .goods .title {
    width: 100%;
    color: #646464 !important;
    font-family: "微软雅黑";
    font-size: 0.75rem;
    margin: 8px auto;
  }

  .right1 .goods .price {
    color: #646464;
    font-family: "微软雅黑";
    font-weight: 500;
    font-size: 20px;
    margin: 0 auto;
  }


  .right1 .goods .good_price {
    margin: 0 auto;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }

  .bottom1 .right1 .right_good_list--image-fill .goods {
    height: auto;
    min-height: 0;
    overflow: hidden;
  }

  .bottom1 .right1 .right_good_list--image-fill .goods dt {
    width: 100%;
    height: auto;
    aspect-ratio: 1 / 1;
    margin: 0;
    overflow: hidden;
  }

  .bottom1 .right1 .right_good_list--image-fill .goods dt img {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .goods1 img {
    width: 100%;
    margin-left: 0;
    margin-top: -0.8rem;
  }

  .bottom1 .right1 .right_good_list--multi-image {
    padding-left: 1%;
    padding-right: 1%;
    gap: 0;
    justify-content: flex-start;
  }

  .bottom1 .right1 .right_good_list--multi-image .goods1 img {
    display: block;
    height: auto;
    margin-top: 0;
    vertical-align: top;
  }

  .bottom1 .right1 .right_good_list--multi-image .goods1,
  .bottom1 .right1 .right_good_list--multi-image .goods1 dt {
    display: block;
    box-sizing: border-box;
    margin: 0;
    padding: 0;
    line-height: 0;
  }

  .bottom1 .right1 .right_good_list--multi-image .goods1 {
    flex: 0 0 100%;
    overflow: hidden;
  }

  .bottom1 .right1 .right_good_list--multi-image .goods1 + .goods1 {
    margin-top: 0 !important;
  }

  .right1 .most {
    display: flex;
    align-items: flex-end;
    justify-content: center;
    color: #999;
    font-size: 14px;
    margin-top: 1.55rem !important;
    display:none;
  }


  .mylian {
    width: 100%;
    height: 40px;
    line-height: 40px;
    background: #10a776;
    text-align: center;
    color: #fff;
    position: fixed;
    bottom: 0;
    max-width: 1000px;
    margin: 0px auto;
  }


  /*在文档流最底部站位专用*/
  .mylian1 {
    width: 100%;
    height: 40px;
    line-height: 40px;
    background-color: transparent;
    /* 设置背景为透明 */
    text-align: center;
    color: #fff;
  }

  .layer {
    width: 100%;
    height: 100vh;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 999999;
    background: #333;
  }

  .layer-in {
    width: 90%;
    margin: auto;
    margin-top: 20%;
    background: #f7f5f5;
    padding: 10px;
    box-sizing: border-box;
  }

  .layer-top {
    width: 100%;
    display: flex;
    justify-content: space-between;
    margin: 10px 0 30px;
  }

  .layer-guan {
    width: 20px;
    height: 20px;
    border: 1px solid #d1d1d1;
    border-radius: 25px;
    font-size: 22px;
    line-height: 20px;
    text-align: center;
    box-sizing: border-box;
  }

  .layer-name {
    font-size: 16px;
    color: #000;
  }

  .layer-shu {
    width: 100%;
    height: 40px;
    border: none;
    background: #fff;
    padding: 0 5px;
    margin: 10px 0;
  }

  .layer-new {
    font-size: 14px;
    color: #000;
  }

  .layer-btn {
    width: 100%;
    height: 50px;
    background: #cc0000;
    color: #fff;
    border-radius: 10px;
    border: none;
    margin-top: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/views/home.vue